// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Wq17","error":"Textarea_error__3oab6","readonly":"Textarea_readonly__3YQip","disabled":"Textarea_disabled__20Pjh"};